// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-to-top {
  z-index: 100;
  position: fixed;
  bottom: 15px;
  right: 15px;
  opacity: 0;
  transition: all 0.2s ease-in-out;
}

.show-scrollTop {
  opacity: 1;
  transition: all 0.2s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/components/scroll-top-button/scroll-top-button.component.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EACD,eAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,gCAAA;AACA;;AACA;EACA,UAAA;EACA,gCAAA;AAEA","sourcesContent":[".scroll-to-top {\r\n\tz-index: 100;\r\nposition: fixed;\r\nbottom: 15px;\r\nright: 15px;\r\nopacity: 0;\r\ntransition: all .2s ease-in-out;\r\n}\r\n.show-scrollTop {\r\nopacity: 1;\r\ntransition: all .2s ease-in-out;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
